import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import type { IProductionStatementCreationJob } from "@/interfaces/api/production-statement-creation-job.interface"
import { ProductionStatementCreationJob } from "@/models/production-statement-creation-job.model"
import { ProductionStatementCreationJobRepository } from "@/repositories/production-statement-creation-job-repository"
import { useProductionStatementCreationJobStore } from "@/store/production-statement-creation-jobs.store"
import { storeToRefs } from "pinia"

export class ProductionStatementCreationJobController extends GenericModelController<
  ProductionStatementCreationJob,
  IProductionStatementCreationJob,
  ProductionStatementCreationJobRepository
> {
  constructor() {
    const productionStatementCreationJobStore = useProductionStatementCreationJobStore()
    const { productionStatementCreationJobs } = storeToRefs(productionStatementCreationJobStore)
    const storeFunctionsConfig = {
      collection: productionStatementCreationJobs
    }

    super(
      ProductionStatementCreationJob,
      storeFunctionsConfig,
      new ProductionStatementCreationJobRepository()
    )

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProductionStatementCreationJob,
      productionStatementCreationJobs
    )
  }

  public async addJobsToStore(
    jobs: IProductionStatementCreationJob[]
  ): Promise<ProductionStatementCreationJob[]> {
    return (await this.storeFunctions.createModel(jobs)) as ProductionStatementCreationJob[]
  }

  public async restartBatch(batchId: string): Promise<ProductionStatementCreationJob[]> {
    const updatedJobs = await this.apiFunctions.getRepository().restartBatch(batchId)
    return updatedJobs.map((job) => this.storeFunctions.updateModel(job)!)
  }

  public async rollback(job: ProductionStatementCreationJob): Promise<void> {
    await this.apiFunctions.getRepository().rollback(job)
    this.storeFunctions.deleteModel(job)
  }
}
